import { CoreModule } from './core';
import { IModuleManifest } from '../types';
import { DashboardModule } from './dashboard';
import { MyAppsModule } from './my-apps';
import { ArchiveAppsModule } from './archive';
import { DefaultAppSettingsModule } from './default-app-settings';
import { CreateNewAppModule } from './create-new-app';
import { ReportsModule } from './reports';

const allModules: IModuleManifest[] = [CoreModule, DashboardModule, CreateNewAppModule, MyAppsModule, ArchiveAppsModule, ReportsModule, DefaultAppSettingsModule];

export default allModules.slice();
